import { useTranslation } from "react-i18next";
import {
  useGetSubdivisionNamesForSelectLazyQuery,
  useGetUsersLazyQuery,
} from "~/schemas/generated/graphql";
import { useEffect } from "react";
import { debounce, get } from "lodash";
import { LANG } from "~/constans/commom";
import { Hooks } from "html-webpack-plugin";
import { log } from "util";

export const useGetUsersForSelect = (): any => {
  const { t } = useTranslation();
  let isEn = localStorage.getItem("language") === LANG.en;

  const [getUsersQuery, { data, loading, fetchMore }] = useGetUsersLazyQuery({
    variables: {
      page: 0,
      count: 25,
      ViolationAccess: true,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    getUsersQuery();
  }, []);

  const users = [
    ...get(data, "UserGetter.getUsers.items", []).map(
      ({ id, fullnameEn, fullname, SubdivisionId }) => {
        return {
          value: id,
          label: isEn ? fullnameEn : fullname,
          SubdivisionId,
        };
      }
    ),
  ];
  const total = get(data, "UserGetter.getUsers.total", 0);

  const intersectionObserver = () => {
    if (users.length < 25) {
      return;
    }
    const page = Math.ceil(users.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },
      updateQuery: ({ UserGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { UserGetter };
        }
        return {
          UserGetter: {
            ...UserGetter,
            getUsers: {
              ...UserGetter.getUsers,
              items: [
                ...UserGetter.getUsers.items,
                ...get(fetchMoreResult, "UserGetter.getUsers.items", []),
              ],
            },
          },
        };
      },
    });
  };

  const searchText = debounce((searchText: string) => {
    getUsersQuery({
      variables: {
        page: 0,
        searchField: searchText ? "fullname" : undefined,
        searchText: searchText || undefined,
        ViolationAccess: true,
      },
    });
  });

  return {
    users,
    intersectionObserver,
    searchText,
    loading,
    total,
  };
};
